import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { JwtService } from './jwt.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ApiService {
  constructor(
    private http: HttpClient,
    private jwtService: JwtService
  ) { }

  private formatErrors(error: any) {
    return throwError(error.error);
  }

  get(path: string, params?): Observable<any> {
    const httpParams = this.getHttpParams(params)
    return this.http.get(`/api/${path}`, { params: httpParams })
      .pipe(catchError(this.formatErrors));
  }

  put(path: string, body: Object = {}): Observable<any> {
    return this.http.put(
      `/api/${path}`,
      JSON.stringify(body)
    ).pipe(catchError(this.formatErrors));
  }

  post(path: string, body: Object = {}): Observable<any> {
    return this.http.post(
      `/api/${path}`,
      JSON.stringify(body)
    ).pipe(catchError(this.formatErrors));
  }

  delete(path: string): Observable<any> {
    return this.http.delete(
      `/api/${path}`
    ).pipe(catchError(this.formatErrors));
  }

  postState(path: string, body: Object = {}): Observable<any> {
    return this.http.post(
      `/api/${path}`,
      JSON.stringify(body)
    ).pipe(catchError(this.formatErrors));
  }

  private getHttpParams(params: Object): HttpParams {
    return Object.getOwnPropertyNames(params).reduce(
      (p, key) => p.set(key, params[key]),
      new HttpParams()
    );
  }

  uploadDocuments(url: string, formData: FormData): Observable<any> {
    return this.http.post(`/api/${url}`, formData, {
      headers: new HttpHeaders({
        enctype: 'multipart/form-data',
        Accept: '*/*'
      })
    });
  }

}
